module.exports = __webpack_public_path__ + "img/Baranova.ca1d582b.jpg";